import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-lux',
  templateUrl: './lux.component.html',
  styleUrls: ['./lux.component.scss']
})
export class LuxComponent implements OnInit {

  page: Object;
  
  constructor(private contentService: ContentService) { 
  }

  ngOnInit() {
    this.page = this.contentService.pages['lux'];
  }

}
